import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as React from "react";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.tooltip + 1,
    color: "#fff",
  },
}));
export type ExtraBackdropProps = {
  text?: string;
};
type Props = {
  open: boolean;
};

const LoadingBackdrop = ({
  open,
  text,
}: Props & ExtraBackdropProps): JSX.Element | null => {
  const classes = useStyles();
  if (!open) return null;

  const typography = text ? <Typography>{text}</Typography> : null;

  return (
    <Backdrop className={classes.backdrop} open>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {typography}
        <CircularProgress color="inherit" />
      </Box>
    </Backdrop>
  );
};

export default LoadingBackdrop;
